import Http from './http';

export default {
  // 根据设备信息获取激活码
  getActivationCode(data) {
    return Http.post('/v2/api/active/code', data);
  },
  // 获取激活状态
  getActiveStatus(data) {
    return Http.get('/v2/api/active/status', data);
  },
  // 获取激活信息
  getActiveInfo(data) {
    return Http.post('/v2/api/active/info', data);
  },
};



// WEBPACK FOOTER //
// ./src/service/dssService.js